"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.clear = exports.removeFiles = exports.fetchFilesFailed = exports.fetchFilesSuccess = exports.fetchFilesRequest = exports.fetchPendingFilesFailed = exports.fetchPendingFilesSuccess = exports.fetchPendingFilesRequest = exports.updateField = exports.sendFailed = exports.sendValidationFailed = exports.sendValidationSuccess = exports.sendSuccess = exports.sendRequest = exports.setStandby = exports.fetchFailed = exports.fetchSuccess = exports.fetchRequest = exports.prepareUploadFailed = exports.prepareUploadSuccess = exports.prepareUploadRequest = void 0;
const ActionTypes = require("../../actionTypes/bid/message");
function prepareUploadRequest(parent, structure) {
    return {
        type: ActionTypes.PREPARE_UPLOAD_REQUEST,
        payload: {
            parent,
            structure
        }
    };
}
exports.prepareUploadRequest = prepareUploadRequest;
function prepareUploadSuccess(createdFolder, structure) {
    return {
        type: ActionTypes.PREPARE_UPLOAD_SUCCESS,
        payload: {
            createdFolder,
            structure
        }
    };
}
exports.prepareUploadSuccess = prepareUploadSuccess;
function prepareUploadFailed(payload) {
    return {
        type: ActionTypes.PREPARE_UPLOAD_FAILED,
        payload
    };
}
exports.prepareUploadFailed = prepareUploadFailed;
function fetchRequest(bid, message) {
    return {
        type: ActionTypes.FETCH_REQUEST,
        payload: {
            bid,
            message
        }
    };
}
exports.fetchRequest = fetchRequest;
function fetchSuccess(mail) {
    return {
        type: ActionTypes.FETCH_SUCCESS,
        payload: mail
    };
}
exports.fetchSuccess = fetchSuccess;
function fetchFailed(payload) {
    return {
        type: ActionTypes.FETCH_FAILED,
        payload
    };
}
exports.fetchFailed = fetchFailed;
function setStandby() {
    return {
        type: ActionTypes.SET_STANDBY
    };
}
exports.setStandby = setStandby;
function sendRequest(bid, to, subject, message, attachments = [], session) {
    return {
        type: ActionTypes.SEND_REQUEST,
        payload: {
            bid,
            message: {
                session,
                attachments,
                to,
                subject,
                message
            }
        }
    };
}
exports.sendRequest = sendRequest;
function sendSuccess() {
    return {
        type: ActionTypes.SEND_SUCCESS
    };
}
exports.sendSuccess = sendSuccess;
function sendValidationSuccess() {
    return {
        type: ActionTypes.SEND_VALIDATION_SUCCESS
    };
}
exports.sendValidationSuccess = sendValidationSuccess;
function sendValidationFailed(payload) {
    return {
        type: ActionTypes.SEND_VALIDATION_FAILED,
        payload
    };
}
exports.sendValidationFailed = sendValidationFailed;
function sendFailed(payload) {
    return {
        type: ActionTypes.SEND_FAILED,
        payload
    };
}
exports.sendFailed = sendFailed;
function updateField(field, value) {
    return {
        type: ActionTypes.UPDATE_FIELD,
        payload: {
            field,
            value
        }
    };
}
exports.updateField = updateField;
function fetchPendingFilesRequest(session) {
    return {
        type: ActionTypes.FETCH_PENDING_FILES_REQUEST,
        payload: session
    };
}
exports.fetchPendingFilesRequest = fetchPendingFilesRequest;
function fetchPendingFilesSuccess(files) {
    return {
        type: ActionTypes.FETCH_PENDING_FILES_SUCCESS,
        payload: files
    };
}
exports.fetchPendingFilesSuccess = fetchPendingFilesSuccess;
function fetchPendingFilesFailed(payload) {
    return {
        type: ActionTypes.FETCH_PENDING_FILES_FAILED,
        payload
    };
}
exports.fetchPendingFilesFailed = fetchPendingFilesFailed;
function fetchFilesRequest(folder) {
    return {
        type: ActionTypes.FETCH_FILES_REQUEST,
        payload: folder
    };
}
exports.fetchFilesRequest = fetchFilesRequest;
function fetchFilesSuccess(files) {
    return {
        type: ActionTypes.FETCH_FILES_SUCCESS,
        payload: files
    };
}
exports.fetchFilesSuccess = fetchFilesSuccess;
function fetchFilesFailed(payload) {
    return {
        type: ActionTypes.FETCH_FILES_FAILED,
        payload
    };
}
exports.fetchFilesFailed = fetchFilesFailed;
function removeFiles(files) {
    return {
        type: ActionTypes.REMOVE_FILES,
        payload: files
    };
}
exports.removeFiles = removeFiles;
function clear() {
    return {
        type: ActionTypes.CLEAR
    };
}
exports.clear = clear;
//# sourceMappingURL=message.js.map